import {ChangeDetectorRef, Component} from '@angular/core';
import {
    AlertController, App, IonicPage, LoadingController, MenuController, NavController, NavParams, Platform,
    ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from '@ionic/storage';
import {SocialSharing} from '@ionic-native/social-sharing';

@Component({
    selector: 'page-add-appointment',
    templateUrl: 'add-appointment.html',
})
export class AddAppointmentPage {
    UserName: any;
    FUserId: any;
    FUserTypeId: any;

    SchoolData: any;
    FSchoolId: any;
    today: any;
    date: any;
    errorDate: any;
    SloteData: any;
    Slote: any;
    EnquiryData: any;

    checksms: any = true;
    Sms: any;
    Phone1: any;
    Phone2: any;

    AptData: any;
    AptDataFromReshedule_CallReminder: any;
    FWebEnquiryId: any;
    AppointmentId: any;

    sibling = "0";
    siblingdata: any;
    CommonId: any;
    AddAll: any;

    call_reminder_data: any;
    FCallStatusId: any;
    FCallReminderId: any;

    title: any;

    userName: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public service: ServiceProvider,
                public platform: Platform,
                menuCtrl: MenuController,
                public loadingCtrl: LoadingController,
                public toastCtrl: ToastController,
                public storage: Storage,
                public _app: App,
                public alertCtrl: AlertController,
                public cdRef: ChangeDetectorRef,
                private socialSharing: SocialSharing,
                public viewCtrl: ViewController) {
        this.platform.ready().then(() => {
            Promise.all([this.storage.get('LoginData'), this.storage.get('UserData')]).then(values => {
                this.today = new Date();
                this.userName = values[1]['Name'];
                this.today = this.today.toISOString();
                this.EnquiryData = navParams.get('data');
                if (this.EnquiryData) {
                    console.log("EnquiryData", this.EnquiryData);
                    this.title = "Add";
                    this.Phone1 = this.EnquiryData.Phone1;
                    this.Phone2 = this.EnquiryData.Phone2;
                    this.FWebEnquiryId = this.EnquiryData.Id;
                    this.sibling = this.EnquiryData.Siblings;
                    this.CommonId = this.EnquiryData.CommonId;
                }
                this.AptData = navParams.get('aptData');
                this.AptDataFromReshedule_CallReminder = navParams.get('Reschedule');
                this.call_reminder_data = navParams.get('callReminder');
                if (this.AptData) {
                    console.log("aptData", this.AptData);
                    console.log("CallData", this.call_reminder_data);
                    this.title = "Reschedule";

                    if (this.AptDataFromReshedule_CallReminder == '1') {
                        //For Reshedule From Call Reminder
                        this.AppointmentId = this.AptData.AmptId;
                        this.FWebEnquiryId = this.AptData.FWebEnquiryId;
                        //For Call Remindre Status
                        this.FWebEnquiryId = this.call_reminder_data.Id;
                        this.FCallStatusId = this.call_reminder_data.FCallStatusId;
                        this.FCallReminderId = this.call_reminder_data.FCallReminderId
                    }
                    else {
                        //For Reshedule From Data
                        this.AppointmentId = this.AptData.Id;
                        this.FWebEnquiryId = this.AptData.FWebEnquiryId;
                    }
                }

                this.siblingdata = navParams.get('siblingdata');
                if (this.siblingdata) {
                    console.log("siblingdata", this.siblingdata);
                    this.title = "Add Sibling";
                    this.sibling = navParams.get('sibling');
                    this.AppointmentId = this.siblingdata.Id;
                    this.FWebEnquiryId = this.siblingdata.FWebEnquiryId;
                }

                this.call_reminder_data = navParams.get('callReminder');
                if (this.call_reminder_data) {
                    console.log("this.call_reminder_data->", this.call_reminder_data);
                    this.FWebEnquiryId = this.call_reminder_data.Id;
                    this.FCallStatusId = this.call_reminder_data.FCallStatusId;
                    this.FCallReminderId = this.call_reminder_data.FCallReminderId;
                    this.sibling = this.call_reminder_data.Siblings;
                    this.CommonId = this.call_reminder_data.CommonId;
                }


                this.UserName = values[1]['Name'];
                this.FUserId = values[0]['FUserId'];
                this.FUserTypeId = values[0]['FUserTypeId'];
                console.log(this.FUserId);
                this.loadSchool();
            });
        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad AddAppointmentPage');
    }

    loadSchool() {
        this.SchoolData = [];
        this.service.httpcall('web_service/get_school?').subscribe(data => {
            console.log(data);
            this.SchoolData = data['data'];
        })
    }

    setSchool() {
        console.log("date", this.FSchoolId);
    }

    setdate() {
        console.log("date", this.date);
        this.SloteData = null;
        this.errorDate = null;
        this.service.httpcall('web_service/get_appointment_slot_by_date?Date=' + this.date + '&FSchoolId=' + this.FSchoolId).subscribe(data => {
            console.log(data);
            if (data['response'] == 'success') {
                this.SloteData = data['data'];
                this.errorDate = null;
            } else {
                this.errorDate = data['error_description'];
            }
        });
    }

    ChckAddAll() {
        console.log('Cucumbers new state:' + this.AddAll);
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    presentToast(msg) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    submit_form() {
        if (this.FSchoolId == null || this.FSchoolId == "") {
            this.presentToast("School Required!");
        } else if (this.date == null || this.date == "") {
            this.presentToast("date Required!");
        } else if (this.Slote == null || this.Slote == "") {
            this.presentToast("Slote Required!");
        } else {

            var json_obj = {};

            if (this.AppointmentId) {
                json_obj['RescheduleId'] = this.AppointmentId;
            }
            json_obj['FWebEnquiryId'] = this.FWebEnquiryId;
            json_obj['FSlotId'] = this.Slote;
            json_obj['Date'] = this.date;
            json_obj['AddedBy'] = this.FUserId;
            json_obj['FSchoolId'] = this.FSchoolId;
            json_obj['Siblings'] = this.sibling;

            let FCommonId = null;
            if (this.AddAll == true) {
                FCommonId = this.CommonId;
                json_obj['CommonId'] = this.CommonId;
            }


            console.log(json_obj);

            let loading = this.loadingCtrl.create({
                content: 'loading'
            });

            loading.present();

            this.service.httppostcall('web_service/add_appointments', json_obj).subscribe(data => {
                console.log(data);
                if (loading)
                    loading.dismiss();
                loading = undefined;
                if (data['response'] == 'success') {
                    //  this.presentToast(data['success_message']);
                    this.FSchoolId = null;
                    this.date = null;
                    this.Slote = null;

                    //updateCall Status
                    if (this.FCallReminderId != undefined || this.FCallReminderId != '') {
                        this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + this.FCallReminderId + '&FCallStatusId=' + this.FCallStatusId + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName + '&CommonId=' + FCommonId, '').subscribe(data1 => {

                            }
                            , (error2 => {

                            }))
                    }

                    this.viewCtrl.dismiss(data['success_message']);
                } else {
                    this.presentToast(data['error_description']);
                }
            }, (err) => {
                loading.dismiss();
                console.log(json_obj);
                this.presentToast("TimeOut!");
            });

        }
    }

    send_whatsapp() {

        let myAlert = this.alertCtrl.create({
            title: 'Send WhatsApp',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'WhatsApp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, "", null, this.Sms);
                        this.checksms = true;

                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: this.Phone1,
            value: this.Phone1
        })
        myAlert.addInput({
            type: 'radio',
            label: this.Phone2,
            value: this.Phone2
        })
        myAlert.present();


    }

    send_msg() {

        let myAlert = this.alertCtrl.create({
            title: 'Send Message',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'WhatsApp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        this.socialSharing.shareViaSMS(this.Sms, '+91' + data);

                        this.checksms = true;
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: this.Phone1,
            value: this.Phone1
        })
        myAlert.addInput({
            type: 'radio',
            label: this.Phone2,
            value: this.Phone2
        })
        myAlert.present();


    }


}



// WEBPACK FOOTER //
// ./src/pages/add-appointment/add-appointment.ts